module.exports = __webpack_public_path__ + "static/media/class-profile.73bc64ac.svg";